// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__GnH7s","titleWithdrawn":"ConsentItem_titleWithdrawn__1usDF","date":"ConsentItem_date__3Pl9C","container":"ConsentItem_container__P40xh"};